const DeviceStatus = ["nn", "ok", "al", "nc", "nf", "wk", "un", "re"];

export default DeviceStatus;
